// Utility functions for scrolling
export const scrollToProjectEnd = (onClose) => {
    if (onClose) {
      onClose(); // Close the section
    }
    const projectSection = document.getElementById("project");
    if (projectSection) {
      projectSection.scrollIntoView({ behavior: "smooth", block: "end" });
    }
  };
  